module.exports = new __parcel__URL__("machine_speed_up_button.0e5fd437.png").toString();